module.exports = __webpack_public_path__ + "static/media/jenis_ekstrakulikuler.ce3b3912.png";